import LandingApp from "../components/LandingApp";

const Index = () => {
  return <LandingApp />;
};

export default Index;
